<section class="desktop-view">
    <div class="grid-container image-content">
        <div></div>
        <div class="pass-image" [ngClass]="{ 'active': isGTP }">
            <xm-media-image [imageOptions]="gtpIcon" size="width"></xm-media-image>
        </div>
        <div class="pass-image" [ngClass]="{ 'active': isMexCan }">
            <xm-media-image [imageOptions]="mexCanIcon" size="width"></xm-media-image>
        </div>
    </div>
    <div class="grid-container column-header">
        <div class="device-header">DEVICE</div>
        <div class="pass-header" [ngClass]="{ 'active': isGTP }">GLOBAL TRAVEL PASS</div>
        <div class="pass-header" [ngClass]="{ 'active': isMexCan }">MEXICO AND CANADA UNLIMITED PASS</div>
    </div>
    <div class="grid-container" *ngFor="let item of tableData">
        <div class="row-data" data-notranslate>{{ item.displayName }}</div>
        <div class="row-data" [ngClass]="{ 'active': isGTP }">{{ item.gtpStatus }}</div>
        <div class="row-data" [ngClass]="{ 'active': isMexCan }">{{ item.mexCanStatus }}</div>
    </div>
</section>
<section class="mobile-view">
    <div class="mobile-grid-container image-content">
        <div class="pass-image">
            <xm-media-image [imageOptions]="gtpIcon" size="width"></xm-media-image>
        </div>
        <div class="pass-image">
            <xm-media-image [imageOptions]="mexCanIcon" size="width"></xm-media-image>
        </div>
    </div>
    <div class="mobile-grid-container column-header">
        <div class="pass-header" [ngClass]="{ 'active': isGTP }">GLOBAL TRAVEL PASS</div>
        <div class="pass-header" [ngClass]="{ 'active': isMexCan }">MEXICO AND CANADA UNLIMITED PASS</div>
    </div>
    <div *ngFor="let item of tableData">
        <div class="line-name" data-notranslate>{{ item.displayName }}</div>
        <div class="mobile-grid-container">
            <div class="row-data">{{ item.gtpStatus }}</div>
            <div class="row-data">{{ item.mexCanStatus }}</div>
        </div>
    </div>
</section>
